export const FILTER_CHIP_KINDS = {
  marketingType: 'marketingType',
  location: 'location',
  objectType: 'objectType',
  propertyType: 'propertyType',
  propertySubType: 'propertySubType',
  range: 'range',
  feature: 'feature',
  preference: 'preference',
} as const;

export type FilterChipKind = (typeof FILTER_CHIP_KINDS)[keyof typeof FILTER_CHIP_KINDS];

export const PROPERTY_TYPE_SELECTION_KINDS = {
  objectType: FILTER_CHIP_KINDS.objectType,
  propertyType: FILTER_CHIP_KINDS.propertyType,
  propertySubType: FILTER_CHIP_KINDS.propertySubType,
} as const;

export type PropertyTypeSelectionKind = (typeof PROPERTY_TYPE_SELECTION_KINDS)[keyof typeof PROPERTY_TYPE_SELECTION_KINDS];
